// extracted by mini-css-extract-plugin
module.exports = {"percentageGratuiti":"gawWYIi98xagZ77-QuqUQ","marginBotGratuiti":"nH0LymD5IeIND86H1fjqB","borderGratuiti":"_6Iiuqod9oD4n56TG7dl-G"};